import type { ID } from '@octopus-do/octopus-project-core'
import type { AppState } from '@store/types'

export const migrationUiSelector = {
  getModalType: (state: AppState) => state.ui.modalType,
  getModalProps: (state: AppState) => state.ui.modalProps,
  getPopupType: (state: AppState) => state.ui.popupType,
  getPopupProps: (state: AppState) => state.ui.popupProps,
  getSyncStatus: (state: AppState) => state.ui.syncStatus,
  getLocks: (id: ID) => (state: AppState) => state.ui.locked[id] || null,
}
